import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu15",
  "use": "icon-menu15-usage",
  "viewBox": "0 0 52 52",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 52 52\" id=\"icon-menu15\">\r\n<polyline fill=\"currentColor\" points=\"8.583,4.166 40.432,2.549 30.545,22.705 40.432,22.705 33.967,31.83 8.583,4.166 \" />\r\n<polygon fill=\"currentColor\" points=\"4.496,6.542 44.805,49.037 43.57,50.275 32.445,38.865 23.89,50.75 23.034,32.307 14.573,33.354 \r\n\t14.763,20.993 3.165,7.969 \" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol